<micro-select-combo #sel
              placeholder="SA Lock Status"
              [mode]="mode"
              [(id)]="saLockStatus"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
